// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SavedSearchDropdown_wrapper_SQR6DOJ","rowItem":"SavedSearchDropdown_rowItem_2rnxIkS"};